// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605110533/js/" + chunkId + "." + {"44":"6bd4add1","225":"674a8fe9","481":"e385670a","486":"df2cc2be","770":"e35412a8"}[chunkId] + ".0.1358960114030543.chunk.js";
};